import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../shared/auth/auth-provider';
import { StaffToastProvider } from '../shared/ui/StaffToast';
import { AppRoutes } from './router/routes';

export function App() {
  return (
    <BrowserRouter>
      <StaffToastProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </StaffToastProvider>
    </BrowserRouter>
  );
}
